// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatContactInfoPanel_root__im-8b {
  border-bottom: 1px solid #E2E2E2;
  display: flex;
  align-items: stretch;
  height: 36px;
  flex-shrink: 0;
}
.ChatContactInfoPanel_root__im-8b > * {
  flex-grow: 1;
  flex-basis: 50%;
  flex-shrink: 0;
}

.ChatContactInfoPanel_button__Uh78D {
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
  border: 0;
  background: transparent;
}
.ChatContactInfoPanel_button__default__htej8 {
  color: #4778EE;
}
.ChatContactInfoPanel_button__danger__nacmK {
  color: #E23834;
}
.ChatContactInfoPanel_button__icon__HyQ7l {
  margin-right: 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/chats/ui/ChatDialogActionsPanel/ChatContactInfoPanel.module.scss"],"names":[],"mappings":"AAAA;EACE,gCAAA;EACA,aAAA;EACA,oBAAA;EACA,YAAA;EACA,cAAA;AACF;AACE;EACE,YAAA;EACA,eAAA;EACA,cAAA;AACJ;;AAGA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,aAAA;EACA,SAAA;EACA,uBAAA;AAFF;AAIE;EACE,cAAA;AAFJ;AAKE;EACE,cAAA;AAHJ;AAME;EACE,iBAAA;AAJJ","sourcesContent":[".root {\n  border-bottom: 1px solid #E2E2E2;\n  display: flex;\n  align-items: stretch;\n  height: 36px;\n  flex-shrink: 0;\n\n  &>* {\n    flex-grow: 1;\n    flex-basis: 50%;\n    flex-shrink: 0;\n  }\n}\n\n.button {\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 400;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  outline: none;\n  border: 0;\n  background: transparent;\n\n  &__default {\n    color: #4778EE;\n  }\n\n  &__danger {\n    color: #E23834;\n  }\n\n  &__icon {\n    margin-right: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ChatContactInfoPanel_root__im-8b`,
	"button": `ChatContactInfoPanel_button__Uh78D`,
	"button__default": `ChatContactInfoPanel_button__default__htej8`,
	"button__danger": `ChatContactInfoPanel_button__danger__nacmK`,
	"button__icon": `ChatContactInfoPanel_button__icon__HyQ7l`
};
export default ___CSS_LOADER_EXPORT___;
